/**
 * Session helpers — partagés entre le tracker propriétaire (§2.K,
 * EPIC-038.4) et le client API (`api.js`, EPIC-009.7) qui injecte
 * `X-Session-Id` sur toutes les requêtes.
 *
 * Un identifiant de visite est amorcé dans `sessionStorage` au premier
 * accès (`crypto.randomUUID()`) et régénéré à chaque ouverture d'onglet
 * — conforme à la décision §2.K *« régénéré à chaque visite »* : pas de
 * cookie, pas de `localStorage`, pas de fingerprinting.
 *
 * En navigation privée stricte où `sessionStorage` jette, on retombe sur
 * un identifiant volatile pour la durée du module (mieux qu'une erreur :
 * l'analytics reste best-effort et ne casse jamais l'UX).
 */

const SESSION_KEY = "nm-session-id";

let memoryFallbackId = null;

/**
 * Retourne le `session_id` de la visite courante en l'amorçant dans
 * `sessionStorage` au besoin. Idempotent — chaque appel retourne le
 * même identifiant tant que l'onglet est ouvert.
 *
 * @returns {string} UUID v4 (ou fallback en navigation privée stricte).
 */
export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch (_e) {
    // sessionStorage indisponible (navigation privée stricte, quota).
    if (!memoryFallbackId) {
      memoryFallbackId = crypto.randomUUID();
    }
    return memoryFallbackId;
  }
}
